import type { MediaFileMetadataRow } from "@next-platform/client-common-core/viewMedia/metadata/buildMediaFileMetadataRows";

import formatMediaFileAddedDate from "./formatMediaFileAddedDate";

export default function formatMetadataValue({ row, locale }: { row: MediaFileMetadataRow; locale: string }): string {
  if (row.kind === "createdAt") {
    const originalValue = row.values[0] ?? "";
    if (!originalValue.trim()) {
      return originalValue;
    }

    const numericTimestamp = Number(originalValue);
    const createdAtMs = Number.isNaN(numericTimestamp) ? Date.parse(originalValue) : numericTimestamp;
    return Number.isNaN(new Date(createdAtMs).getTime()) ? originalValue : formatMediaFileAddedDate({ createdAtMs, locale });
  }

  if (row.kind === "dimensions") {
    return row.values.map((value) => value.replace("×", " × ")).join(", ");
  }

  return row.values.join(", ");
}
